@if (loaderIcon | async) {
  <app-loader></app-loader>
}
<div class="modal fade" bsModal #SMSLogs="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal_80" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">SMS</h5>
        <button type="button" class="close" (click)="onCancel()" aria-label="close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="overflow-y: hidden;">
        <div class="info-section mb-3 d-flex justify-content-between" style="margin-right: 50px;">
          <p><strong>Name:</strong> {{tenantDetails.TenantName}}</p>
          <p><strong>Phone:</strong> {{tenantDetails.Phone| phone: 1}}</p>
          <p><strong>Email:</strong> {{tenantDetails.EmailID}}</p>
          <p><strong>Address:</strong> {{tenantDetails.Address}}</p>
          <p><strong>City:</strong> {{tenantDetails.City}}</p>
        </div>
        <div class="row mx-0 mt-3">
          <div class="scroll_outer">
            <div class="large_scroll_inner">
              <ejs-tooltip #tooltip position='BottomCenter' target=".e-rowcell.customcss">
                <ejs-grid #grid class="Table_Height_tabhistory table-striped table-ipad e-control e-grid e-lib e-gridhover e-responsive e-default e-droppable e-tooltip e-keyboard" height='100%' [gridLines]='lines'
                  (dataBound)='dataBound(grid)' allowFiltering='true' allowSorting='true' [filterSettings]='filterSettings' [dataSource]='SMSLogsResponse' (mouseover)='mouseover($event)'>
                  <e-columns>
                    <e-column field='FacilityDateTime' textAlign='Left' headerText='Created Date' width='50'>
                    </e-column>
                    <e-column field='UnitNo' textAlign='Left' headerText='Unit #' width='30'>
                    </e-column>
                    <e-column field='UserName' textAlign='Left' headerText='Created By' width='65'>
                    </e-column>
                    <e-column field='Status' headerText='Type' width='30' textAlign='Center'>
                    </e-column>
                    <e-column field='Message' headerText='Text' width='120' textAlign='Center' [customAttributes]='customAttri'>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </ejs-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3" data-bs-toggle="modal"
        (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
